import React, { useEffect, useRef, useState } from "react";
import { Input, Form, Button, Select } from "Components";
import { useIntl } from "react-intl";
import useOptions from "Modules/dashboard/views/landmarkVisit/constants/options";
import { useSelector } from "react-redux";
import TagsManage from "Modules/.common/components/TagsManage";


//styles
import "./landmarkVisit.scss";

const CreateEditOfflineLandmarkVisit = (props) => {
  const { onSubmit, handleClose } = props;
  const { messages, locale } = useIntl();
  const { optionsTimeMetric, optionsFrequency, entities, parameterOrder } =
    useOptions(messages);
  const refForm = useRef(null);
  const [isLandmarksValid, setIsLandmarksValid] = useState(true);
  const { loadingCreateEdit, gadGet } = useSelector(
    (state) => state.dashboardPanelRedux
  );
  const [formData, setFormData] = useState({
    name: "",
    refreshSeconds: "",
    optionsTimeMetric: "",
    parameterOrder: "",
    landmarksToSearch: [],
  });
  const [localLoading, setLocalLoading] = useState(true);

  useEffect(() => {
    setIsLandmarksValid(formData.landmarksToSearch.length > 0);
  }, [formData.landmarksToSearch]);

  useEffect(() => {
    if (gadGet.hasOwnProperty("name")) {
      try {
        let settings = JSON.parse(gadGet.settings);
        setFormData({
          name: gadGet.name,
          refreshSeconds: optionsFrequency.find(
            (x) => x.id == settings?.refreshSeconds
          ),
          optionsTimeMetric: optionsTimeMetric.find(
            (x) => x.id == settings?.timeMetric
          ),
          parameterOrder: parameterOrder.find(
            (x) => x.id == settings?.parameterOrder
          ),
          landmarksToSearch: settings?.landmarksToSearch,
        });
      } catch (error) {
        // Handle the error appropriately, e.g., set default form data or show an error message
        setFormData({
          name: "",
          refreshSeconds: "",
          optionsTimeMetric: "",
          parameterOrder: "",
          landmarksToSearch: [],
        });
      }
    }
    setLocalLoading(false);
    return () => {
      setFormData({
        name: "",
        refreshSeconds: "",

        landmarksToSearch: [],
      });
    };
  }, [open, gadGet]);

  const validateData = () => {
    if (!isLandmarksValid) return;

    const dataToValidate = {
      name: formData?.name,
      refreshSeconds: formData?.refreshSeconds.id,
      landmarksToSearch: formData?.landmarksToSearch,
      timeMetric: formData?.optionsTimeMetric.id,
      parameterOrder: formData?.parameterOrder.id,
    };

    onSubmit(dataToValidate);
  };

  const onChangeEntity = (newSelectedEntity) => {
    if (newSelectedEntity.id == "All") {
      setFormData({
        ...formData,
        landmarksToSearch: [{ id: "-1", name: "All" }],
      });
      setIsLandmarksValid(true);
    } else {
      setFormData({ ...formData, landmarksToSearch: [] });
      setIsLandmarksValid(false);
    }
  };

  const onChange = (selectedItems, entity) => {
    setFormData({ ...formData, landmarksToSearch: selectedItems });
    setIsLandmarksValid(selectedItems.length > 0);
  };

  const entity = entities.find(
    (x) =>
      x.id ==
      ((formData.landmarksToSearch?.find(
        (x) => x.id == "-1" && x?.name == "All"
      ) &&
        "All") ||
        "Landmark")
  );

  return (
    <section className="landmark_visit">
      <Form
        className="landmark_visit__form"
        ref={refForm}
        onValidSubmit={validateData}
      >
        <Input
          id="name"
          value={formData.name}
          onChange={(value) => setFormData({ ...formData, name: value })}
          minLength={1}
          maxLength={25}
          label={messages["dashboardPanel_edit_title"]}
          placeholder={messages["dashboardPanel_edit_title"]}
          type="text"
          required
          requiredMessage={messages["required_field"]}
        />
        <Select
          label={messages["dashboardPanel_edit_frequency"]}
          name="refreshSeconds"
          isLoading={false}
          options={optionsFrequency}
          textField="name"
          value={formData?.refreshSeconds}
          valueField="id"
          placeholder={messages["dashboardPanel_edit_frequency"]}
          isSearchable={false}
          onChange={(value) =>
            setFormData({ ...formData, refreshSeconds: value })
          }
          isClearable
          required
          requiredMessage={messages["required_field"]}
        />
        <Select
          label={messages["reportsMainRT_selectTimeFrame"]}
          name="refreshSeconds"
          isLoading={false}
          options={optionsTimeMetric}
          textField="name"
          value={formData?.optionsTimeMetric}
          valueField="id"
          placeholder={messages["reportsMainRT_selectTimeFrame"]}
          isSearchable={false}
          onChange={(value) =>
            setFormData({ ...formData, optionsTimeMetric: value })
          }
          isClearable
          required
          requiredMessage={messages["required_field"]}
        />
        <Select
          label={messages["dashboardPanel_order_By"]}
          name="parameterOrder"
          isLoading={false}
          options={parameterOrder}
          textField="name"
          value={formData?.parameterOrder}
          valueField="id"
          placeholder={messages["dashboardPanel_order"]}
          isSearchable={false}
          onChange={(value) =>
            setFormData({ ...formData, parameterOrder: value })
          }
          isClearable
          required
          requiredMessage={messages["required_field"]}
        />
        <section className="landmark_visit__landmarks">
          <div className={isLandmarksValid ? "labelLandmark" : "text-danger"}>
            <label>
              {!isLandmarksValid ? (
                <span>
                  {messages["alertsNewAlert_landmarkValidation"]}
                  <span style={{ color: "red" }}> *</span>
                </span>
              ) : (
                <span>
                  {messages["alertsNewAlert_landmarkValidation"]}
                  <span style={{ color: "red" }}> *</span>
                </span>
              )}
            </label>
          </div>
          {!localLoading && (
            <div style={{ marginTop: 5 }}>
              <TagsManage
                entities={entities}
                value={formData.landmarksToSearch || []}
                onChange={onChange}
                mode="list"
                height={400}
                entitySelected={entity}
                setEntitySelected={(entity) => {
                  onChangeEntity(entity);
                }}
              />
            </div>
          )}
        </section>
      </Form>
      <section className="landmark_visit__bottons">
        <Button
          variant="secondary"
          isDisabled={false}
          className="btn-cancel"
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {messages["cancel"]}
        </Button>
        <Button
          variant="primary"
          isDisabled={false}
          onClick={(e) => {
            if (e) e.preventDefault();
            refForm.current.submit();
          }}
          className="btn-blue"
        >
          {messages["save"]}
        </Button>
      </section>
    </section>
  );
};

export default CreateEditOfflineLandmarkVisit;
